import { AutoLinkNode, LinkNode } from '@lexical/link'
import { ListItemNode, ListNode } from '@lexical/list'
import { QuoteNode } from '@lexical/rich-text'

import { GroupMentionNode } from '../nodes/GroupMentionNode'
import { MentionNode } from '../nodes/MentionNode'

export const editorNodes = [ListNode, ListItemNode, QuoteNode, AutoLinkNode, LinkNode, MentionNode, GroupMentionNode]
